export default __webpack_public_path__ + "static/media/photo--sm--138.720864ce.jpg";